export interface Comment {
  id: string;
  advertisementId: string;
  author: string;
  body: string;
  created: string;
  state: CommentState;
}

export enum CommentState {
  NEW = 'NEW',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}
